import React, { useState } from "react";
import {
  dismissTaskStatusAttention,
  listPendingTaskStatus,
  listTaskStatusAttention,
} from "../../helpers/tasks/taskStatusQueue";

/** C8: queued offline task changes and changes the server refused on sync. */
export function TaskSyncBanner({ actor, projectId }) {
  const [, force] = useState(0);
  const inProject = (x) => !projectId || !x.project_id || x.project_id === projectId;
  const pending = listPendingTaskStatus(actor).filter(inProject);
  const attention = listTaskStatusAttention(actor).filter(inProject);
  if (pending.length === 0 && attention.length === 0) return null;
  return (
    <div data-testid="task-sync-banner">
      {pending.length > 0 ? (
        <div className="tk-notice" role="status" data-testid="task-sync-pending">
          {pending.length === 1 ? "1 task change is" : `${pending.length} task changes are`} waiting to sync.
        </div>
      ) : null}
      {attention.map((item) => (
        <div className="rec-banner" role="alert" key={item.mutation_id} data-testid="task-sync-attention">
          {item.title ? <strong>{item.title}: </strong> : null}
          {item.message}{" "}
          <button
            type="button"
            className="nx-btn nx-btn-ghost"
            onClick={() => {
              dismissTaskStatusAttention(actor, item.mutation_id);
              force((n) => n + 1);
            }}
          >
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
}
